import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
const LanguageContext = createContext(void 0);
const useLanguage = (fallbackLanguage) => {
  const context = useContext(LanguageContext);
  if (!context) {
    return { language: fallbackLanguage };
  }
  return context;
};
const LanguageProvider = ({ children, language }) => {
  const value = useMemo(
    () => ({
      language
    }),
    [language]
  );
  return /* @__PURE__ */ jsx(LanguageContext.Provider, { value, children });
};
export {
  LanguageContext,
  LanguageProvider as default,
  useLanguage
};
//# sourceMappingURL=language.js.map
